$(".disable-form :input").attr("disabled", true);

$(document).on("turbolinks:load", function() {
  // $(".panel-default h4").click(function(){
  //   $("span").removeClass("arrow-down");
  //    $(".collapsed span").addClass("arrow");
  //   //alert("dsgffg");
  // });

 // Add down arrow icon for collapse element which is open by default
    $(".collapse.show").each(function(){
      $(this).prev(".panel-default").find("a span").addClass("arrow-down").removeClass("arrow");
    });
    
    // Toggle right and down arrow icon on show hide of collapse element
    $(".collapse").on('show.bs.collapse', function(){
      $(this).prev(".panel-default").find("a span").removeClass("arrow").addClass("arrow-down");
    }).on('hide.bs.collapse', function(){
      $(this).prev(".panel-default").find("a span").removeClass("arrow-down").addClass("arrow");
    });
    
  var set_states = function(country_code, attendee_info) {
    var select_wrapper = attendee_info.find(".guest-container").find("#event_ticket_state");
    $('select', select_wrapper).attr('disabled', true);
    var url =  $("#subregions_path").val(); 
    var url = url +
              "?" +
              $.param({
                parent_region: country_code,
                model_name: "event_ticket"
              });
    select_wrapper.load(url);
  };
  
  $("a.event-order-div").first().click();
});

$(document).on("change", "[id=event_ticket_country]" , function() {
  var country_code =  $(this).val();
  var attendee_info = $(this).closest("[id*=ticket_info]");
  set_states(country_code, attendee_info);
});

$(document).on("click", "a.event-order-div", function() {
  var order_id = $(this).data("order");
  console.log(order_id);

  $("div[id^='ticket_info_']").each(function(){
    var id = $(this).data("order");
    if(order_id == id){
      $(this).slideToggle();
    }
  })
})
